/**
 * RBAC module slug is `edit_lecture` (UI label: Edit Lecture).
 * Keep in sync with backend checkPermission() on routes and permissionSeeds.js.
 */

export const EDIT_LECTURE_DEPARTMENT_VIEW = "edit_lecture.department_view";
export const EDIT_LECTURE_OVERRIDE = "edit_lecture.override";
export const EDIT_LECTURE_OWN_OVERRIDE = "edit_lecture.own_override";
export const EDIT_LECTURE_VIEW = "edit_lecture.view";

/** Any of these grants access to the Edit Lecture menu / routes. */
export const EDIT_LECTURE_MENU_PERMISSIONS = [
  EDIT_LECTURE_VIEW,
  EDIT_LECTURE_DEPARTMENT_VIEW,
  EDIT_LECTURE_OVERRIDE,
  EDIT_LECTURE_OWN_OVERRIDE,
];
